export const CertificateList = [
 {
    title: "AI Fluency: Framework & Foundations",
    date: "2026-03-06",
    image: require('../assets/ai-fluency-cert.png'),
    type: "Certificate",
    company: "Anthropic",
    link: "https://verify.skilljar.com/c/fvm6ikdsp7yt"
 },
 {
    title: "AI Fluency for students",
    date: "2026-03-23",
    image: require('../assets/ai-student-cert.png'),
    type: "Certificate",
    company: "Anthropic",
    link: "http://verify.skilljar.com/c/9rw2dunv4w4p"
 },
 {
    title: "Claude 101",
    date: "2026-03-06",
    image: require('../assets/claude-101-cert.png'),
    type: "Certificate",
    company: "Anthropic",
    link: "https://verify.skilljar.com/c/gp4k8qkvizak"
 },
 {
    title: "Claude Code in Action",
    date: "2026-03-02",
    image: require('../assets/claude-code-cert.png'),
    type: "Certificate",
    company: "Anthropic",
    link: "https://verify.skilljar.com/c/u63ryzwmmuab"
 },
 {
    title: "Microsoft Certified Professional",
    date: "2014-07-26",
    image: require('../assets/microsoft-professional-cert.png'),
    type: "Certificate",
    company: "Microsoft"
 },
 {
    title: "Microsoft Specialist: Programming in HTML5 with JavaScript and CSS3",
    date: "2014-07-26",
    image: require('../assets/html5-cert.png'),
    type: "Certificate",
    company: "Microsoft"
 },
 /*{
    title: "Create machine learning models with Azure",
    date: "2014-07-26",
    image: require('../assets/Code_Dependent.jpg'),
    type: "Badge",
    company: "Microsoft"
 },*/
];